module.exports = __webpack_public_path__ + "static/media/0520-r.c9e6af6c.png";